import _ from "lodash";
import React from "react";
import styled from "styled-components";

import { ReactComponent as ICON_OVERVIEW_CAMPAIGN } from "@assets/svgs/ICON_OVERVIEW_CAMPAIGN.svg";
import { ReactComponent as ICON_OVERVIEW_DEVICES } from "@assets/svgs/ICON_OVERVIEW_DEVICES.svg";
import { ReactComponent as ICON_OVERVIEW_MEDIA } from "@assets/svgs/ICON_OVERVIEW_MEDIA.svg";
import { ReactComponent as ICON_OVERVIEW_PROJECTS } from "@assets/svgs/ICON_OVERVIEW_PROJECTS.svg";
import { Text } from "@components/Text";

const Container = styled.div`
  display: grid;
  gap: 16px;
  height: 161px;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  flex-shrink: 0;
`;

const ContainerBlock = styled.div`
  width: 100%;
  height: 100%;
  padding: 16px;
  gap: 16px;
  border-radius: 16px;
  background: white;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background: linear-gradient(360deg, #ffffff 38.51%, #e1fff8 130.12%);
  box-sizing: border-box;
`;

const ContainerMainDetail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: end;
`;

const ContainerGroupDetail = styled.div`
  display: flex;
  flex-direction: column;
`;

const ContainerDetail = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 8px;
`;

const ContainerActivity = styled.div`
  display: flex;
  gap: 8px;
  padding: 0px 12px;
  align-items: center;
  border-radius: 50px;
  background: ${({ background }) => background};
`;

export const OverviewHeader = ({ overviewHeaderData = null }) => {
  const totalDevices = _.get(overviewHeaderData, ["totalDevices"]);
  const totalCampaigns = _.get(overviewHeaderData, ["totalCampaigns"]);
  const totalMedias = _.get(overviewHeaderData, ["totalMedias"]);
  const totalProjects = _.get(overviewHeaderData, ["totalProjects"]);

  return (
    <Container>
      <ContainerBlock>
        <ContainerMainDetail>
          <ContainerGroupDetail>
            <ICON_OVERVIEW_DEVICES />
            <Text style={{ marginTop: 8 }} fontSize={"16px"} fontWeight="600">
              Total Devices
            </Text>
          </ContainerGroupDetail>
          <ContainerGroupDetail style={{ alignItems: "end" }}>
            <Text fontSize={"30px"} fontWeight="700">
              {_.get(totalDevices, ["total"])}
            </Text>
            <Text fontSize={"16px"} fontWeight="400">
              Devices
            </Text>
          </ContainerGroupDetail>
        </ContainerMainDetail>
        <ContainerDetail>
          <ContainerActivity background="#e6ffe4">
            <Text fontSize={"16px"} fontWeight="700" color="#26AF1A">
              {_.get(totalDevices, ["total_online"])}
            </Text>
            <Text fontSize={"14px"} fontWeight="500" color="#26AF1A">
              Online
            </Text>
          </ContainerActivity>
          <ContainerActivity background="#FFE5E5">
            <Text fontSize={"16px"} fontWeight="700" color="#D93737">
              {_.get(totalDevices, ["total_offline"])}
            </Text>
            <Text fontSize={"14px"} fontWeight="500" color="#D93737">
              Offline
            </Text>
          </ContainerActivity>
        </ContainerDetail>
      </ContainerBlock>
      <ContainerBlock>
        <ContainerMainDetail>
          <ContainerGroupDetail>
            <ICON_OVERVIEW_CAMPAIGN />
            <Text style={{ marginTop: 8 }} fontSize={"16px"} fontWeight="600">
              Total Campaigns
            </Text>
          </ContainerGroupDetail>
          <ContainerGroupDetail style={{ alignItems: "end" }}>
            <Text fontSize={"30px"} fontWeight="700">
              {_.get(totalCampaigns, ["total"])}
            </Text>
            <Text fontSize={"16px"} fontWeight="400">
              Campaigns
            </Text>
          </ContainerGroupDetail>
        </ContainerMainDetail>
        <ContainerDetail>
          <ContainerActivity background="#e6ffe4">
            <Text fontSize={"16px"} fontWeight="700" color="#26AF1A">
              {_.get(totalCampaigns, ["total_onair"])}
            </Text>
            <Text fontSize={"14px"} fontWeight="500" color="#26AF1A">
              On Air
            </Text>
          </ContainerActivity>
        </ContainerDetail>
      </ContainerBlock>
      <ContainerBlock>
        <ContainerMainDetail>
          <ContainerGroupDetail>
            <ICON_OVERVIEW_PROJECTS />
            <Text style={{ marginTop: 8 }} fontSize={"16px"} fontWeight="600">
              Total Projects
            </Text>
          </ContainerGroupDetail>
          <ContainerGroupDetail style={{ alignItems: "end" }}>
            <Text fontSize={"30px"} fontWeight="700">
              {_.get(totalProjects, ["total"])}
            </Text>
            <Text fontSize={"16px"} fontWeight="400">
              Projects
            </Text>
          </ContainerGroupDetail>
        </ContainerMainDetail>
      </ContainerBlock>
      <ContainerBlock>
        <ContainerMainDetail>
          <ContainerGroupDetail>
            <ICON_OVERVIEW_MEDIA />
            <Text style={{ marginTop: 8 }} fontSize={"16px"} fontWeight="600">
              Total Medias
            </Text>
          </ContainerGroupDetail>
          <ContainerGroupDetail style={{ alignItems: "end" }}>
            <Text fontSize={"30px"} fontWeight="700">
              {_.get(totalMedias, ["total"])}
            </Text>
            <Text fontSize={"16px"} fontWeight="400">
              Files
            </Text>
          </ContainerGroupDetail>
        </ContainerMainDetail>
        <ContainerDetail>
          <ContainerActivity background="#e6ffe4">
            <Text fontSize={"14px"} fontWeight="400" color="#26AF1A">
              Active
            </Text>
            <Text fontSize={"16px"} fontWeight="700" color="#26AF1A">
              {_.get(totalMedias, ["total_active"])}
            </Text>
            <Text fontSize={"14px"} fontWeight="400" color="#5E6366">
              / {_.get(totalMedias, ["total"])}
            </Text>
          </ContainerActivity>
        </ContainerDetail>
      </ContainerBlock>
    </Container>
  );
};
